import React from "react";
import { Button } from "antd";
import api from "../../services/api";

export default class ReportPastas extends React.Component {
  handleOnClick = async endpoint => {
    const res = await api.get(endpoint);
    console.log(res.data);
    window.open("http://api.debt.com.br/" + res.data.relatorio);
  };

  render() {
    return (
      <React.Fragment>
        <br />
        <br />
        <Button onClick={() => this.handleOnClick("/importacao_report/")}>
          Relatorio de Pastas da Importação
        </Button>
        <br />
        <br />
        <Button onClick={() => this.handleOnClick("/filtro_report/")}>
          Relatorio de Pastas do Filtro
        </Button>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Relatorios/RelatorioPastas.js